import React, {useRef} from 'react';
import {Link} from 'react-router-dom';
import {Button, Grid, CircularProgress} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {PList} from 'components/TypographyShortcuts.jsx';
import ModalImage from 'components/ModalImage';
import useGetFiles from 'hooks/useGetFiles';
import {dateFormatter, numberDaysBetween} from 'components/forms/locale/utils';
import VesselServicesCard from 'components/forms/VesselServicesCard';
import Show from 'components/utils/Show';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        // width: '100%',
        '& > *': {
            marginBottom: '1em',
        },
    },
}));

const SSLInfo = ({state}) => (
    <Grid item>
        <PList>
            <b>Sea Service Letter Summary</b>
        </PList>
        <PList>
            <b>Letter Date:</b> {state.date_document_signed}
        </PList>
        <PList>
            <b>Total Days on Letter:</b> {state.number_days_on_letter}
        </PList>
        <PList>
            <b>Operating Company:</b> {state.operating_company}
        </PList>
        <Show condition={state.user_tankerman_id}>
            <PList style={{margin: '1em 0'}}>
                <Button
                    variant='contained'
                    color='primary'
                    component={Link}
                    to={`/document/tankerman/${state.user_tankerman_id}`}
                >
                    View linked Tankerman Letter
                </Button>
            </PList>
        </Show>
    </Grid>
);

const NOAATOSSInfo = ({state, sslType}) => {
    const name =
        sslType === 'noaatoss'
            ? 'NOAA'
            : sslType === 'uscgtoss'
            ? 'USCG'
            : sslType === 'armytoss'
            ? 'Army'
            : '';

    let sum = 0;
    state.vessel_entries?.forEach(vessel => {
        vessel.service_entries?.forEach(position => {
            sum += numberDaysBetween(
                position.date_reported,
                position.date_detached
            );
        });
    });

    return (
        <Grid item>
            <PList>
                <b>{name} Transcript of Sea Service Summary</b>
            </PList>
            <PList>
                <b>TOSS Date:</b> {dateFormatter(state.date_document_signed)}
            </PList>
            {state.number_days_on_letter ? (
                <PList>
                    <b>Total Days Assigned to Vessels:</b>{' '}
                    {state.number_days_on_letter}
                </PList>
            ) : null}
            {sum ? (
                <PList>
                    <b>Total Days Assigned to Vessels:</b> {sum}
                </PList>
            ) : null}
            {sum ? (
                <PList>
                    <b>Total Days Credit:</b> {Math.round(sum * 6) / 10}
                </PList>
            ) : null}
        </Grid>
    );
};

const SSLDisplay = ({showPicture = true, inForm, state, children}) => {
    const classes = useStyles();
    const {files, isLoading} = useGetFiles(
        state?.user_document_post_response?.user_images?.map(image => image.id)
    );
    const containerRef = useRef(null);
    const sslType = state?.ssl_type;

    const ShowInfo =
        sslType === 'ssl'
            ? SSLInfo
            : sslType === 'noaatoss'
            ? NOAATOSSInfo
            : sslType === 'armytoss'
            ? NOAATOSSInfo
            : sslType === 'uscgtoss'
            ? NOAATOSSInfo
            : SSLInfo;

    return (
        <Grid container spacing={1}>
            <Grid item container justifyContent='space-around'>
                <Grid item xs={12} sm={10} md={8}>
                    {children}
                </Grid>
            </Grid>
            {showPicture ? (
                <Grid
                    item
                    container
                    className={classes.root}
                    justifyContent='space-evenly'
                    alignItems='center'
                    ref={containerRef}
                >
                    {isLoading ? (
                        <CircularProgress />
                    ) : (
                        files?.map((image, index) => (
                            <Grid item key={`review-document-${index}`}>
                                <ModalImage
                                    alt={`uploaded document page ${index + 1}`}
                                    src={image.thumb_signed_url}
                                    fullSrc={image.signed_url}
                                    filename={image.document_filename}
                                    mimeType={image.mime_type}
                                    ref={containerRef}
                                />
                            </Grid>
                        ))
                    )}
                </Grid>
            ) : null}
            <ShowInfo state={state} sslType={sslType} />
            <Grid item container direction='column' spacing={2}>
                {state.vessel_entries?.map((vessel, index) => {
                    return (
                        <Grid item key={`vessel-${index}`}>
                            <VesselServicesCard
                                vesselData={vessel}
                                index={index}
                                inForm={inForm}
                            />
                        </Grid>
                    );
                })}
            </Grid>
        </Grid>
    );
};

export default SSLDisplay;
